var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_15307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_15307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4602 28.0266L24.5352 22.9516C24.8172 22.6696 25.1495 22.4683 25.5321 22.3474C25.9147 22.2266 26.3074 22.2065 26.7102 22.287L28.2811 22.6193C27.1936 23.9082 26.3377 25.0762 25.7133 26.1235C25.089 27.1707 24.4849 28.4394 23.9008 29.9297L19.4602 28.0266ZM25.6529 30.7756C26.1161 29.3256 26.7455 27.9561 27.541 26.6672C28.3364 25.3783 29.2981 24.17 30.4258 23.0422C32.1981 21.27 34.222 19.9459 36.4977 19.0698C38.7734 18.1938 40.8981 17.9269 42.8717 18.2693C43.214 20.2429 42.9522 22.3676 42.0863 24.6433C41.2203 26.919 39.9012 28.9429 38.129 30.7151C37.0213 31.8228 35.813 32.7844 34.504 33.6C33.1949 34.4157 31.8154 35.0551 30.3654 35.5183L25.6529 30.7756ZM33.9904 27.1506C34.4536 27.6137 35.0225 27.8453 35.6972 27.8453C36.3719 27.8453 36.9408 27.6137 37.404 27.1506C37.8672 26.6874 38.0988 26.1184 38.0988 25.4438C38.0988 24.7691 37.8672 24.2002 37.404 23.737C36.9408 23.2738 36.3719 23.0422 35.6972 23.0422C35.0225 23.0422 34.4536 23.2738 33.9904 23.737C33.5272 24.2002 33.2956 24.7691 33.2956 25.4438C33.2956 26.1184 33.5272 26.6874 33.9904 27.1506ZM33.1446 41.6808L31.2113 37.2401C32.7015 36.6561 33.9753 36.0519 35.0326 35.4276C36.0899 34.8033 37.263 33.9474 38.5519 32.8599L38.854 34.4308C38.9345 34.8335 38.9144 35.2313 38.7936 35.624C38.6727 36.0167 38.4713 36.354 38.1894 36.636L33.1446 41.6808ZM21.3936 34.6422C22.0984 33.9374 22.9543 33.5799 23.9613 33.5698C24.9682 33.5598 25.8241 33.9071 26.529 34.612C27.2338 35.3169 27.5863 36.1728 27.5863 37.1797C27.5863 38.1867 27.2338 39.0426 26.529 39.7474C26.0255 40.2509 25.1847 40.6839 24.0066 41.0464C22.8285 41.4089 21.2022 41.7311 19.1279 42.0131C19.4099 39.9387 19.7321 38.3176 20.0946 37.1495C20.4571 35.9815 20.8901 35.1457 21.3936 34.6422Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_15307",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_15307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_15307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_15307",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchicon);
export default __webpack_public_path__ + "static/media/launch+icon.513ae0178e7f3015bdd65154deed2a10.svg";
export { ForwardRef as ReactComponent };